import { useEffect } from "react";
import { BaseFormScaffoldState } from "../FormScaffold.types";
import FormScaffoldResetEvent from "../utils/FormScaffoldResetEvent";

export default function useSubscribeToFormScaffoldEvent<T extends BaseFormScaffoldState>(
    callback: (event: FormScaffoldResetEvent<T>) => void,
) {
    useEffect(() => {
        FormScaffoldResetEvent.addListener(callback);
        return () => {
            FormScaffoldResetEvent.removeListener(callback);
        };
    }, []);
}
